module.exports = __webpack_public_path__ + "static/icon-70ec77ac2081c5a446622abc16c1ccd0.jpg";